import api from "app/api";
import { Options } from "common";
import { WaiverFormItem } from "features/waivers/waiverApi";

enum SharingStatus {
  Active = "ACTIVE",
}

export type SharingListItem = {
  id: number;
  name: string;
  token: string;
  status: SharingStatus;
  location_id: number;
  created_by: number;
  status_label: string;
  location_label: string;
  created_by_label: string;
  sharing_waivers: {
    id: number;
    waiver_id: number;
    name: string;
  }[];
};
export type SharingFormItem = {
  id: number;
  token: string;
  name: string;
  status: SharingStatus;
  account_id: number;
  location_id: number;
  created_at: string;
  created_by: number;
  deleted_at: string;
  deleted_by: number;
  waiver_ids: number[];
  tags: string[];
}; //& SharingListItem;

export type SharingItem = {
  id: number;
  name: string;
  status: SharingStatus;
  status_label: string;
  location_id: number;
  location_label: string;
  waivers: WaiverFormItem[];
}; //& SharingListItem;

export type SharingOptions = Options<"location_id" | "tags" | "waiver_ids">;

export function getSharingService() {
  return api.getService<SharingFormItem, SharingListItem, SharingOptions>(
    "sharings",
    {
      itemExporter: item => {
        return { SharingForm: item };
      },
    }
  );
}

export function loadSharingByToken(token?: string) {
  return api.get<{ success: boolean; data: SharingItem; message: string }>(
    `/sharing/view?token=${token}`
  );
}
export function submitSharingWaiver(token?: string, data?: any) {
  return api.post<{ success: boolean; data: SharingItem; message: string }>(
    `/sharing/submit?token=${token}`,
    data
  );
}
